module.exports = __webpack_public_path__ + "static/media/recruit_230_develop.50c36a03.png";